import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import CreateOrder from '../views/order/CreateOrder'
import OrderDetail from '../views/order/OrderDetail'
import ChannelMain from '../views/channel/ChannelMain'
import ChannelEdit from '../views/channel/ChannelEdit'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta:{
      title:"账号登录"
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title:"订单管理"
    }
  },
  {
    path: '/order/createOrder/:type',
    name: 'CreateOrder',
    component: CreateOrder,
    meta:{
      title:"创建订单"
    }
  },
  {
    path: '/order/detail/:enId',
    name: 'OrderDetail',
    component: OrderDetail,
    meta:{
      title:"订单详情"
    }
  },
  {
    path: '/channel',
    name: 'ChannelMain',
    component: ChannelMain,
    meta:{
      title:"渠道管理"
    }
  },
  {
    path: '/channel/edit/:enId',
    name: 'ChannelEdit',
    component: ChannelEdit,
    meta:{
      title:"添加渠道"
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta:{
      title:"关于"
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
